import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, Outlet } from 'react-router-dom';

import BackIconButton from 'Src/components/buttons/BackIconButton';
import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { HeaderMainNav } from 'Src/components/navigation/HeaderMainNav';
import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import { PageMainHeader } from 'Src/feature/page/PageMainHeader';
import { PagePanelHeader } from 'Src/feature/page/PagePanelHeader';
import useRoute from 'Src/routes/useRoute';

const sectionId = 'SettingsPage';

const SettingsPage: FC = () => {
  const { t } = useTranslation();
  const { navigate, location, crumbs, route } = useRoute();

  const buttons = [
    { label: t('settings.labels.printers'), route: crumbs.pos.settings.printers.path },
    { label: t('settings.labels.cardReader'), route: crumbs.pos.settings.cardReader.path },
    { label: t('settings.labels.networkTest'), route: crumbs.pos.settings.networkTest.path },
  ];

  const navButtons = buttons.map((button) => {
    const selected = Boolean(matchPath(location.pathname, button.route));
    return {
      ...button,
      selected,
    };
  });

  const onBackClick = () => {
    navigate(crumbs.pos.checks.main.interpolate({ tabId: route.params.value.checksList }));
  };

  return (
    <Page
      data-testid={sectionId}
      panel={(
        <Flex gap="xs">
          <PagePanelHeader>
            <BackIconButton onClick={onBackClick} />
            <Copy variant="h6" value={t('settings.label')} />
          </PagePanelHeader>
          {navButtons.map(({ route, label, selected }) => (
            <CTA
              key={label}
              onClick={() => navigate(route)}
              selected={selected}
              label={label}
            />
          ))}
        </Flex>
      )}
      main={(
        <PageMain
          header={<PageMainHeader end={<HeaderMainNav />} />}
          main={<Outlet />}
        />
      )}
    />
  );
};

export default SettingsPage;
export { sectionId };
